import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoanCalculatorModel } from '../../model/loan-calculator.model';
import { CompanyModel } from '../../model/company.model';
import { DirectorModel } from '../../model/director.model';
import { BizflexState } from './bizflex.reducer';
import { LeadModel } from '../../model/lead.model';

export type SetAccessTokenProps = {
  accessToken: string | null;
};

export type SetSignTokenProps = {
  signToken: string;
};

export type SetApplicationIdProps = {
  applicationId: string;
};

export type SetCompanyProps = {
  company: CompanyModel;
};

export type SetCurrencyCodeProps = {
  currencyCode: string;
};

export type SetDirectorProps = {
  director: DirectorModel;
};

export type SetDirectorsProps = {
  directors: DirectorModel[];
};

export type SetLoanCalculatorProps = {
  loanCalculator: LoanCalculatorModel;
};

export type ResetStateProps = {
  initialState: Partial<BizflexState>;
};

export type LeadSubmissionTokenProps = {
  leadSubmissionToken: string;
};

export type LeadSubmissionProps = {
  leadSubmission: LeadModel;
};

export const BizflexActions = createActionGroup({
  source: 'Bizflex',
  events: {
    Init: emptyProps(),
    Reset: props<ResetStateProps>(),
    'Set Access Token': props<SetAccessTokenProps>(),
    'Set Sign Token': props<SetSignTokenProps>(),
    'Set Application Id': props<SetApplicationIdProps>(),
    'Set Company': props<SetCompanyProps>(),
    'Set Currency Code': props<SetCurrencyCodeProps>(),
    'Set Director': props<SetDirectorProps>(),
    'Set Directors': props<SetDirectorsProps>(),
    'Set Loan Calculator': props<SetLoanCalculatorProps>(),
    'Set Lead Submission Token': props<LeadSubmissionTokenProps>(),
    'Set Lead Submission': props<LeadSubmissionProps>(),
  },
});
